<template>
  <div class="industry" v-show="is_show_page">
    <div class="list" v-if="list.length > 0">
      <div class="list-head algin-center font-sc-me">
        <div v-if="search_type == 2" class="head-item border-right-line">
          油品类型
        </div>
        <div v-if="search_type == 2" class="head-item border-right-line">
          产品名称
        </div>
        <div class="head-item border-right-line">
          行业
        </div>
        <div
          class="head-item"
          :class="search_type == 1 ? 'border-right-line' : ''"
        >
          应用部位
        </div>
        <div v-if="search_type == 1" class="head-item">产品推荐</div>
      </div>
      <div class="container">
        <van-list
          v-model="is_loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          v-model:error="is_error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <div
            class="list-item algin-center"
            v-for="(item, index) in list"
            :key="index"
            @click="goProduct(item.id)"
          >
            <div v-if="search_type == 2" class="item item-esp">
              {{ item.oils_type }}
            </div>
            <div v-if="search_type == 2" class="item">
              {{ item.shell_product
               }}
            </div>
            <div
              class="item item-esp"
              :class="search_type == 2 ? '' : 'pad-l-20'"
            >
              {{ item.industry }}
            </div>
            <div class="item ellipses" v-if="search_type == 2">{{ item.application_position }}</div>
            <div class="item double-line-ellipses" v-if="search_type == 1">{{ item.application_position }}</div>


            <div v-if="search_type == 1" class="item">
              {{ item.shell_product }}
            </div>
            <div class="arrow-right flex">
              <img src="../../../assets/arrow_right_blue.png" alt="" />
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <empty-list v-if="list.length == 0"></empty-list>
  </div>
</template>

<script>
import {
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
  getCurrentInstance
} from "vue";
import { useRouter } from "vue-router";
import EmptyList from "./Emtpy";
import Api from "../../../api/ProductApi";
import { throttle } from "../../../libs/tools";

export default {
  name: "IndustryDetail",
  components: {
    EmptyList
  },
  props: {
    // 关键字
    keywords: {
      type: String
    },
    // 1-关键字 2-行业
    search_type: {
      type: [Number, String]
    },
    // 是否从首页搜索进入
    from: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    let datas = reactive({
      keywords: "",
      search_type: "",
      from: "",
      page: 1,
      size: 20,
      list: [],
      is_loading: false, // 数据是否在加载中
      finished: false, // 是否全部数据加载完成
      is_error: false, // 列表加载是否错误 v-model:error 与 :error.sync 同意 :error不会触发load事件
      is_first: true, // 首次进入页面
      is_show_page: false // 页面是否展示
    });
    // 获取数据
    const getList = async () => {
      try {
        if (datas.is_first) {
          // 首次展示加载中
          proxy.$toast.loading({
            message: "加载中..."
          });
        }
        datas.is_loading = true;
        let params = {
          page: datas.page,
          size: datas.size
        };
        if (datas.from == 1) {
          params.keywords = datas.keywords;
        } else if (datas.search_type == 1) {
          params.industry = datas.keywords;
        } else {
          params.shell_product = datas.keywords;
        }
        const { code, data, meta } = await Api.oilsList(params);
        if (datas.is_first) {
          proxy.$toast.clear();
        }
        datas.is_first = false;
        datas.is_loading = false;
        if (code == 0) {
          datas.is_error = false;
          datas.page++;
          datas.list = datas.list.concat(data);
          if (datas.list.length >= meta.total) {
            datas.finished = true;
          }
        } else {
          datas.is_error = true;
        }
        datas.is_show_page = true;
      } catch (errror) {
        datas.is_error = true;
        console.error(errror);
      }
    };
    // 跳转行业详情
    const goProduct = id => {
      router.push({
        name: "Detail",
        query: {
          id
        }
      });
    };
    // 上拉加载
    const onLoad = throttle(function() {
      getList();
    }, 1000);
    onMounted(() => {
      datas.keywords = props.keywords;
      datas.search_type = props.search_type;
      datas.from = props.from || "";
      getList();
    });
    onUnmounted(() => {
      datas.list = [];
      datas.page = 1;
      datas.is_first = true;
    });
    return {
      ...toRefs(datas),
      goProduct,
      getList,
      onLoad
    };
  }
};
</script>

<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
::v-deep(van-list__error-text)
  font-size: vw(24)
::v-deep(.van-list__finished-text)
  font-size: vw(24)
::v-deep(.van-list__loading)
  font-size: vw(24)
.industry
  font-size: vw(28)
  .text-center
    text-align: center
  .list
    margin: vw(0) vw(40)
    padding: vw(30) 0
    // padding-bottom: vw(30)
    .list-head
      height: vw(80)
      color: #FFFFFF
      background: #5E7BFF
      box-shadow: 0 vw(10) vw(20) 0 rgba(94, 123, 255, 0.3)
    .head-item
      text-align: center

      flex: 1
    .border-right-line
      border-right: vw(1) solid rgba(255,255,255, 0.6)
    .container
      overflow-y: auto
      max-height: calc( 100vh - 140px )
      background: #FFFFFF
      .pad-l-20
        padding-left: vw(20)
      .list-item
        position: relative
        padding: vw(30) 0 vw(30) 0

        justify-content: space-between
        align-items: center
        min-height: vw(100)
        &::after
          content: " "
          width: vw(608)
          height: vw(2)
          background-color: #F1F2FA
          position: absolute
          left: vw(32)
          bottom: 0
        .item
          padding: 0 vw(4) 0 vw(4)
          width: vw(150)
          flex: 1
          text-align: center
          line-height: 1.2
        .item-esp
          overflow: hidden
          white-space: nowrap
          text-overflow: ellipsis
          word-break: break-all
        .arrow-right
          position: absolute
          top: 0
          right: 0
          width: vw(76)
          // height: vw(80)
          height: 100%
          display: flex
          align-items: center
          img
            width: vw(76)
            height: vw(80) 
  .list::-webkit-scrollbar
    display: none
</style>
